module.exports = __webpack_public_path__ + "static/media/sugestion.ae446d0b.png";